import React, { useEffect, useState } from "react";
import DialogBox from "../../component/DialogBox";
import InputField from "../../component/InputField";
import ButtonCompo from "../../component/ButtonCompo";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AlertBox from "../../component/AlertBox";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import SelectField from "../../component/SelectField";
import {
  LinearProgress,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import PaginationBar from "../../component/PaginationBar";

function ManagerProjects() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (employeeData !== null && employeeData?.adminRole !== "manager") {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [allProjects, setAllProjects] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [reload, setReload] = useState(false);

  //fetch all projects
  async function getProjects() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/projects/get/all/manager/${page}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data?.data || []);
      setAllProjects(res.data?.data?.data || []);
      setTotalPages(res.data?.data?.totalPages || 0);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Projects fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getProjects();
  }, [reload, page]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center flex-col">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Project Management
          </h1>
          <div className="w-full mt-5">
            {allProjects.length === 0 ? (
              <div>
                <p className="text-center text-[18px] text-slate-500 font-medium">
                  No project found
                </p>
              </div>
            ) : (
              <div className="shadow-lg">
                <Table>
                  <TableHead>
                    <TableRow className="!bg-blue-500">
                      <TableCell className="!text-center !text-white">
                        SL No
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Project Name
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Started From
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Deadline
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        View
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allProjects.map((data, i) => (
                      <TableRow>
                        <TableCell className="!text-center">{i + 1}</TableCell>
                        <TableCell className="!text-center">
                          {data?.name}
                        </TableCell>
                        <TableCell className="!text-center">
                          {new Date(data?.startDate).toLocaleDateString(
                            "en-IN"
                          )}
                        </TableCell>
                        <TableCell className="!text-center">
                          {new Date(data?.deadline).toLocaleDateString("en-IN")}
                        </TableCell>
                        <TableCell className="!text-center">
                          <Link to={`/admin/get/single/project/manager/${data?._id}`}>
                            <ButtonCompo>View</ButtonCompo>
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <PaginationBar
                  attendancePage={page}
                  setAttendancePage={setPage}
                  totalAttendancePage={totalPages}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ManagerProjects;